import axios from 'axios';

export const remissionGuideApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-remission-guide`,
    headers: {
        'Content-Type': 'application/json'
    }
})
